module.exports = __webpack_public_path__ + "img/ger_empty_folder.5e69d804.png";